<template>
  <a-modal width="55%" title="审核信息" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
      <!--提交之后 未初审-->
      <a-descriptions :column="2" title='园区确认信息' v-if="form.isSubmit != 0  && form.isSubmit != 5">
          <a-descriptions-item label="确认状态">
              <span v-if="form.notarizeStatus==1" style="color:green">确认通过</span>
              <span v-if="form.notarizeStatus==2" style="color:red">确认未通过</span>
          </a-descriptions-item>
          <a-descriptions-item label="确认时间">{{ form.notarizeTime }}</a-descriptions-item>
          <a-descriptions-item label="确认原因" :span="2" >{{ form.notarizeRemark }}</a-descriptions-item>
      </a-descriptions>
      <!-- 有一个审核不通过时 -->
      <a-descriptions :column="2" title='初审信息'
                      v-if="form.auditStatus == 3 || (form.firstAuditStatus != 0 && form.secondAuditStatus == 0)">
          <a-descriptions-item label="初审状态">
              <span v-if="form.firstAuditStatus==1" style="color:green">通过</span>
              <span v-if="form.firstAuditStatus==2" style="color:red">不通过</span>
          </a-descriptions-item>
          <a-descriptions-item label="初审时间">{{ form.firstAuditTime }}</a-descriptions-item>
          <a-descriptions-item label="初审原因" :span="2">{{ form.firstAuditRemark }}</a-descriptions-item>
      </a-descriptions>
      <a-descriptions :column="2" title='复审信息'
                      v-if="form.auditStatus == 3 && (form.firstAuditStatus != 0 && form.secondAuditStatus != 0)">
          <a-descriptions-item label="初审状态">
              <span v-if="form.firstAuditStatus==1" style="color:green">通过</span>
              <span v-if="form.firstAuditStatus==2" style="color:red">不通过</span>
          </a-descriptions-item>
          <a-descriptions-item label="复审时间">{{ form.secondAuditTime }}</a-descriptions-item>
          <a-descriptions-item label="复审原因" :span="2">{{ form.secondAuditRemark }}</a-descriptions-item>
      </a-descriptions>
      <!-- 审核全部通过时 -->
      <a-descriptions :column="2" title='初审信息'
                      v-if="form.auditStatus == 2">
          <a-descriptions-item label="初审状态">
              <span v-if="form.firstAuditStatus==1" style="color:green">通过</span>
              <span v-if="form.firstAuditStatus==2" style="color:red">不通过</span>
          </a-descriptions-item>
          <a-descriptions-item label="初审时间">{{ form.firstAuditTime }}</a-descriptions-item>
          <a-descriptions-item label="初审原因" :span="2">{{ form.firstAuditRemark }}</a-descriptions-item>
      </a-descriptions>
      <a-descriptions :column="2" title='复审信息'
                      v-if="form.auditStatus == 2">
          <a-descriptions-item label="初审状态">
              <span v-if="form.firstAuditStatus==1" style="color:green">通过</span>
              <span v-if="form.firstAuditStatus==2" style="color:red">不通过</span>
          </a-descriptions-item>
          <a-descriptions-item label="复审时间">{{ form.secondAuditTime }}</a-descriptions-item>
          <a-descriptions-item label="复审原因" :span="2">{{ form.secondAuditRemark }}</a-descriptions-item>
      </a-descriptions>
  </a-modal>
</template>
<script>
import { formMixin } from "@/mixins";
export default {
  name: "DetailModal",
  components: {

  },

  mixins: [formMixin,],
  data() {
    return {
      form: {
        id: null,
      },
    }
  },
}
</script>
<style scoped lang="less"></style>
